import { useQuery } from '@tanstack/react-query'
import api from 'api/api'

// Member count and (when the money line is rolled out to this user) the
// channel's 30-day upvalue and host earnings, from one request per channel.
export function useStreamCardStats(team: { id: string } | null) {
    const { data } = useQuery({
        queryKey: ['team-card-stats', team?.id],
        queryFn: () => api.getTeamCardStats(String(team?.id)),
        enabled: team?.id != null && gon.currentUser != null,
        staleTime: 5 * 60 * 1000,
    })

    return {
        membersCount: data?.members_count ?? null,
        hostName: data?.host_name ?? null,
        upvalueSats: data?.upvalue_sats_30d ?? null,
        hostEarningsSats: data?.host_earnings_sats_30d ?? null,
    }
}
